export default {
  'viewTemplate.templateDetails': 'Template Details',
  'viewTemplate.templateName': 'Template Name'
};
